module.exports = __webpack_public_path__ + "img/WhiteYellow.ca3862ec.svg";